var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShuffleLine = function SvgShuffleLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.9 17.295V15.6l4.5 2.7-4.5 2.7v-1.881a8.1 8.1 0 0 1-6.297-4.829l-.003-.004-.003.005A8.1 8.1 0 0 1 4.153 19.2H3.5v-1.8h.652a6.3 6.3 0 0 0 5.791-3.819L10.621 12l-.678-1.581A6.3 6.3 0 0 0 4.153 6.6H3.5V4.8h.652a8.1 8.1 0 0 1 7.445 4.91l.003.004.003-.005A8.1 8.1 0 0 1 17.9 4.88V3l4.5 2.7-4.5 2.7V6.705a6.3 6.3 0 0 0-4.643 3.714L12.579 12l.678 1.581a6.3 6.3 0 0 0 4.643 3.714"
  })));
};
export default SvgShuffleLine;